import POShipmentPreBookingSearchType from './POShipmentPreBookingSearchTypes';

export const getShipmentPreBookingInfoListInProgress = () => {
  return { type: POShipmentPreBookingSearchType.GET_SHIPMENT_PRE_BOOKING_INFO_LIST };
};

export const getShipmentPreBookingInfoListInSuccess = (payload) => {
  return {
    type: POShipmentPreBookingSearchType.GET_SHIPMENT_PRE_BOOKING_INFO_LIST_SUCCESS,
    payload,
  };
};

export const getShipmentPreBookingInfoListListInFail = (payload) => {
  return {
    type: POShipmentPreBookingSearchType.GET_SHIPMENT_PRE_BOOKING_INFO_LIST_FAIL,
    payload,
  };
};

export const getShipmentPreBookingInfoListListInReset = (payload) => {
  return {
    type: POShipmentPreBookingSearchType.GET_SHIPMENT_PRE_BOOKING_INFO_LIST_RESET,
    payload,
  };
};

export const updateShipmentPreBookingInfoListRequest = (payload) => {
  return {
    type: POShipmentPreBookingSearchType.UPDATE_SHIPMENT_PRE_BOOKING_INFO_LIST_REQUEST,
    payload,
  };
};

export const updateShipmentPreBookingInfoCheckedItems = (payload) => {
  return {
    type: POShipmentPreBookingSearchType.UPDATE_SHIPMENT_PRE_BOOKING_INFO_LIST_CHECKED_ITEMS,
    payload,
  };
};

export const setShipmentPreBookingSearchExportModal = (payload) => {
  return {
    type: POShipmentPreBookingSearchType.SET_SHIPMENT_PRE_BOOKING_SEARCH_EXPORT_TOGGLE,
    payload,
  };
};
